function full_name_validator(values, errors) {
  if (values.full_name.length === 0) { errors.full_name = 'وارد کردن نام کامل الزامی می باشد'; }
  else if (!/^[\u0600-\u06FF\s\u200c]+$/.test(values.full_name)) { errors.full_name = 'نام و نام خانوادگی وارد شده معتبر نمی باشد' }
  else if (values.full_name.length < 5) { errors.full_name = 'تعداد حروف وارد شده کمتر از حد مجاز می باشد' }
  else if (!values.full_name.includes(' ')) { errors.full_name = 'لطفا نام و نام خانوادگی را با فاصله از یکدیگر بنویسید ' }
  else if (values.full_name.length > 80) { errors.full_name = 'تعداد حروف وارد شده بیش از حد مجاز می باشد' }
}

function email_validator(values, errors) {
  if (values.email.length === 0) { errors.email = 'وارد کردن ایمیل الزامی می باشد' }
  else if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(values.email)) { errors.email = 'ایمیل وارد شده معتبر نمی باشد' }
}

function phone_validator(values, errors) {
  if (values.phone.length === 0) { errors.phone = 'وارد کردن شماره همراه الزامی می باشد' }
  else if (!/^09\d{9}$/.test(values.phone)) { errors.phone = 'شماره وارد شده معتبر نمی باشد' };
}

function institute_validator(values, errors) {
  if (values.institute.length === 0) { errors.institute = 'وارد کردن نام مرکز الزامی می باشد' }
  else if (!/^[\u0600-\u06FFa-zA-Z0-9\s()‌\-.,]{2,100}$/.test(values.institute)) { errors.institute = 'لطفا یک نام معتبر وارد نمایید' };
}

function subject_validator(values, errors) {
  if (values.subject.length === 0) { errors.subject = 'لطفا موضوع درخواست خود را وارد نمایید' }
}

function files_validator(values, errors) {
  if (values.files) {
    if (values.files.length > 10) { errors.files = 'تعداد فایل ها نباید بیشتر از 10 عدد باشد' };
    for (let file of values.files) {
      if (file.size > 1024 * 1024) { errors.files = 'حجم هر فایل نباید بیشتر از 1 مگابایت باشد' };
    }
  }
}

function message_validator(values, errors) {
  if (values.message.length === 0) { errors.message = 'لطفا متن درخواست خود را وارد نمایید' }
}


export {
  full_name_validator,
  phone_validator,
  email_validator,
  institute_validator,
  subject_validator,
  files_validator,
  message_validator,
}